// Platform-console date formatting (design sweep): one unambiguous format
// everywhere — "17 Jun 2026" — instead of 60+ locale-dependent
// toLocaleDateString() calls that render 6/17/2026 for some operators and
// 17/06/2026 for others. (The tenant-side org date preference is a different
// system; this console is platform-scoped.)
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function fmtDate(d: Date | string | number | null | undefined): string {
  if (d === null || d === undefined || d === '') return '—';
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return String(d);
  return `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}

export function fmtDateTime(d: Date | string | number | null | undefined): string {
  if (d === null || d === undefined || d === '') return '—';
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return String(d);
  const hh = String(date.getHours()).padStart(2, '0');
  const mi = String(date.getMinutes()).padStart(2, '0');
  return `${fmtDate(date)} ${hh}:${mi}`;
}
